module.exports = __webpack_public_path__ + "img/orange_bws_logo.7ac28bd5.png";